import { gql } from '@apollo/client';

const VISITISH_CLINICIAN_RECOMMENDATION = gql`
    fragment ClinicianRecommendation on VisitishClinicianAppointmentClinicianRecommendation {
        clinician {
            ...ClinicianOptionFragment
        }
        recommendationRank
        isSatisfactory
        isCompatible
        wouldClinicianBeOverfullByAmortizedVisitDuration
        llmNotesParsingScore
        llmNotesParsingReason
        licenseValue
        careTeamScore
        continuityOfCareScore
        compensationTypeScore
        spareShiftHours
        spareShiftHoursNormalizedScore
        satisfiesGenderPreference
        satisfiesLanguagePreference
        distanceFromFutureVisitsCentroidMi
        isInDefaultTerritory
        hasShiftWithTerritoryCoverage
        hasShiftWithQualificationMatch
    }
`;

const INCOMPATIBLE_CLINICIAN = gql`
    fragment IncompatibleClinician on ClinicianCompatibilityResult {
        clinician {
            ...ClinicianOptionFragment
        }
        compatibilityResult {
            isCompatible
            incompatibilities {
                description
                type
            }
        }
    }
`;

// Base fragments select recommendations only (no compatibility/incompatibleClinicians).
// Used by bulk-style flows (BulkClinicianContext, GetBulkClinicianRecommendations,
// GetIndividualClinicianRecommendations, OrderDetailsClinicianAssignmentRecommendations).
// Anywhere that doesn't render the Not Recommended tab.
export const VISIT_RECOMMENDED_CLINICIANS_BASE_FRAGMENT = gql`
    fragment VisitRecommendedCliniciansBase on VisitClinicianAppointmentClinicianRecommendations {
        clinicianAppointment {
            id
            clinician {
                ...ClinicianOptionFragment
            }
            visit {
                id
            }
            entity: visit {
                id
            }
        }
        clinicianRecommendations: recommendedCliniciansGivenOtherRecommendations {
            ...ClinicianRecommendation
        }
    }

    ${VISITISH_CLINICIAN_RECOMMENDATION}
`;

export const VISIT_REQUEST_RECOMMENDED_CLINICIANS_BASE_FRAGMENT = gql`
    fragment VisitRequestRecommendedCliniciansBase on VisitRequestClinicianAppointmentClinicianRecommendations {
        clinicianAppointment {
            id
            clinician {
                ...ClinicianOptionFragment
            }
            visitRequest {
                id
            }
            entity: visitRequest {
                id
            }
        }
        clinicianRecommendations: recommendedCliniciansGivenOtherRecommendations {
            ...ClinicianRecommendation
        }
    }

    ${VISITISH_CLINICIAN_RECOMMENDATION}
`;

// Extended fragments add compatibility.incompatibleClinicians for the Not Recommended tab.
// Currently used only by reassign.
export const VISIT_RECOMMENDED_CLINICIANS_FRAGMENT = gql`
    fragment VisitRecommendedClinicians on VisitClinicianAppointmentClinicianRecommendations {
        ...VisitRecommendedCliniciansBase
        compatibility {
            incompatibleClinicians {
                ...IncompatibleClinician
            }
        }
    }

    ${VISIT_RECOMMENDED_CLINICIANS_BASE_FRAGMENT}
    ${INCOMPATIBLE_CLINICIAN}
`;

export const VISIT_REQUEST_RECOMMENDED_CLINICIANS_FRAGMENT = gql`
    fragment VisitRequestRecommendedClinicians on VisitRequestClinicianAppointmentClinicianRecommendations {
        ...VisitRequestRecommendedCliniciansBase
        compatibility {
            incompatibleClinicians {
                ...IncompatibleClinician
            }
        }
    }

    ${VISIT_REQUEST_RECOMMENDED_CLINICIANS_BASE_FRAGMENT}
    ${INCOMPATIBLE_CLINICIAN}
`;
